import React from 'react';
import etgLogo from '../assets/etg.png';
import ufmgLogo from '../assets/Ufmg-sem nome-03.png';
import '../styles/home.css';

const TermsOfUse = () => {
  return (
    <div className="tipo-ambiente-container">
      <div className="header-controls">
        <button className="btn-back" onClick={() => window.history.back()}><i className="fas fa-arrow-left"></i></button>
      </div>
      <div className="header">
        <div className="title-container">
          <img src={etgLogo} alt="ETG Logo" className="logo" />
          <h1>Termos de Uso</h1>
          <img src={ufmgLogo} alt="UFMG Logo" className="logo" />
        </div>
      </div>
      <div className="text-container">
        <h2>1. Aceitação dos Termos</h2>
        <p>Ao acessar e usar este aplicativo, você aceita e concorda em ficar vinculado aos termos e disposições deste contrato.</p>
        <h2>2. Uso do Serviço</h2>
        <p>Você concorda em usar o serviço apenas para fins legais e de uma maneira que não infrinja os direitos, restrinja ou iniba o uso e gozo do aplicativo por qualquer outra pessoa.</p>
        <h2>3. Propriedade Intelectual</h2>
        <p>Os direitos de propriedade intelectual de todo o software e conteúdo (incluindo imagens fotográficas) disponibilizados a você neste ou através deste aplicativo permanecem propriedade do proprietário do aplicativo ou de seus licenciadores e são protegidos por leis e tratados de direitos autorais em todo o mundo.</p>
        <h2>4. Isenção de Responsabilidade</h2>
        <p>O material exibido neste aplicativo é fornecido sem quaisquer garantias, condições ou garantias quanto à sua precisão.</p>
        <h2>5. Lei Aplicável</h2>
        <p>Estes termos e condições devem ser interpretados de acordo com as leis do Brasil e, no caso de qualquer disputa ou reclamação associada a estes termos e condições, essa disputa ou reclamação estará sujeita à jurisdição exclusiva dos tribunais brasileiros.</p>
      </div>
    </div>
  );
};

export default TermsOfUse;